import { useEffect, useState } from 'react';
import { InViewHookResponse, useInView } from 'react-intersection-observer';
import {
  WIDGET_VISIBILITY_THRESHOLD,
  WIDGET_VISIBILITY_TIMEOUT,
} from 'utils/constants';
import useStaticCallback from './useStaticCallback';

interface UseWidgetViewConfig {
  disabled?: boolean;
  onView: () => void;
}

export default function useWidgetView({
  disabled,
  onView,
}: UseWidgetViewConfig): Pick<InViewHookResponse, 'ref'> {
  const [triggered, setTriggered] = useState(false);
  const handleView = useStaticCallback(onView);

  const { inView, ref } = useInView({
    skip: disabled || triggered,
    threshold: WIDGET_VISIBILITY_THRESHOLD,
  });

  useEffect(() => {
    let active = true;
    let timerId: number;

    if (inView) {
      timerId = window.setTimeout(() => {
        if (active) {
          setTriggered(true);
          handleView();
        }
      }, WIDGET_VISIBILITY_TIMEOUT);
    }

    return () => {
      if (timerId) {
        window.clearTimeout(timerId);
      }
      active = false;
    };
  }, [handleView, inView, setTriggered]);

  return { ref };
}
